/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-12-02 15:34:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-02 15:43:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/TextAlignment/index.tsx
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import styles from './style.less';
import { TextAlign } from '@/src/types/common';

type Props = {
  value: TextAlign;
  onChange: (v: TextAlign) => void;
};

function TextAlignment({ value, onChange }: Props) {
  return (
    <div className={styles.container}>
      <Icon
        type={
          value === TextAlign.LEFT ? 'iconleft-active' : 'iconleft-inactive'
        }
        onClick={() => onChange && onChange(TextAlign.LEFT)}
        style={{ color: value === TextAlign.LEFT ? '#38C568' : undefined }}
        className={styles.icon}
      />
      <Icon
        type={
          value === TextAlign.CENTER
            ? 'iconcentre-active'
            : 'iconcentre-inactive'
        }
        onClick={() => onChange && onChange(TextAlign.CENTER)}
        style={{ color: value === TextAlign.CENTER ? '#38C568' : undefined }}
        className={styles.icon}
      />
      <Icon
        type={
          value === TextAlign.RIGHT ? 'iconright-active' : 'iconright-inactive'
        }
        onClick={() => onChange && onChange(TextAlign.RIGHT)}
        style={{ color: value === TextAlign.RIGHT ? '#38C568' : undefined }}
        className={styles.icon}
      />
      <Icon
        type={
          value === TextAlign.JUSTIFY
            ? 'icondisribute-active'
            : 'icondisribute-inactive'
        }
        onClick={() => onChange && onChange(TextAlign.JUSTIFY)}
        style={{ color: value === TextAlign.JUSTIFY ? '#38C568' : undefined }}
        className={styles.icon}
      />
    </div>
  );
}

export default TextAlignment;
